export default "__VITE_ASSET__DEPzWDeN__"